module.exports = ".size15 {\n  witdh: 15%; }\n\n.tablediv {\n  padding-left: 13px;\n  padding-right: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/statistics-view/statistics-view.component.scss
// module id = ./src/app/+app-custom/views/statistics-view/statistics-view.component.scss
// module chunks = main